<template>
  <div id="app"> 
    <sistema-suspenso
      v-if="sistemaSuspenso"
      :titulo="suspensao.titulo"
      :mensagem="suspensao.mensagem"
    ></sistema-suspenso>
    <router-view v-else
        :aviso-feriado-bancario="avisoFeriadoBancario"   
    ></router-view>

  </div>
</template>

<script>
import SistemaSuspenso from './pages/erros/SistemaSuspenso.vue';  
export default {
  components: { SistemaSuspenso },
  data() {
    return {
      sistemaSuspenso: false,
      suspensao: {
        titulo: 'Serviço temporariamente indisponível',
        mensagem: 'Tente novamente mais tarde.' 
      },
      avisoFeriadoBancario: false
    };
  },

  watch: {
    situacao: {
      immediate: true,
      handler(novoValor) {
        if (novoValor === 'SUSPENSO') {
          this.avisoFeriadoBancario = true;
          this.sistemaSuspenso = true;
          this.suspensao.mensagem = this.$store.state.mensagem;
        } else {
          this.avisoFeriadoBancario = false;
          this.sistemaSuspenso = false;
          this.suspensao.mensagem = null;
        }
      }
    }
  },

  computed: {
    situacao() {
      return this.$store.state.situacao
    },
    mensagem() {
      return this.$store.state.mensagem
    }
  },

  async beforeMount() {
    // Carregar o script do reCAPTCHA dinamicamente
    if (this.$env.recaptchaSiteKey) {
      const recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/enterprise.js?render=${this.$env.recaptchaSiteKey}`)
      document.head.appendChild(recaptchaScript)
      // só prosseguir depois que o script for carregado ou falhar ao carregar
      await new Promise((resolve) => {
        recaptchaScript.onload = resolve
        recaptchaScript.onerror = resolve
      });
    }
  }
  
};
</script>
